import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import estadoMock from '../../../common/mock/estadoMock';
import {PRIVADO} from '../../../common/types/modalidadTrasladoType';

import vehiculoService from '../../../service/logistica/vehiculoService';
import transporteService from '../../../service/logistica/transporteService';
import modalidadTrasladoService from '../../../service/logistica/modalidadTrasladoService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import choferService from '../../../service/logistica/choferService';
import global from '../../../common/utility/global';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            estados: estadoMock.values,
            choferes: [],
            transportes: [],
            modalidadTraslado: [],
            filter: {
                nombreChofer: '',
                estado: '',
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            color: '',
            marca: '',
            modelo: '',
            placa: '',
            idChofer: 0,
            idTransporte: 0,
            idModalidadTraslado: PRIVADO,
            flagTransportePrivado: true,
            tuc:'',
            /***********/
            choferes: [],
            transportes: [],
            modalidadTraslado: [],
        }
    };

    handleClearFilters = () => {
        var filter = {
            nombreChofer: '',
            estado: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }

    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        var response = await vehiculoService.excel(this.state.filter);

        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Vehículo.xlsx");
    }

    handleExportPdf = async () => {

    }

    handlePrint = async () => {

    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await vehiculoService.eliminar(values);
            else
                response = await vehiculoService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleChangeForm = async (property, value) => {
        
        if (property === "clear") {
            this.setState({
                formValues: {
                    ...this.state.formValues
                }
            });
        }
    };

    /******************** FORM MODAL *****************/

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.choferes = this.state.choferes;
        formValues.transportes = this.state.transportes;
        formValues.modalidadTraslado = this.state.modalidadTraslado;
        this.setState({ visible: true, formValues });
    };

    handleEdit = async (values) => {
        var response = await vehiculoService.obtenerPorId(values.id);
        if (response !== undefined) {
            response.choferes = this.state.choferes;
            response.transportes = this.state.transportes
            response.modalidadTraslado = this.state.modalidadTraslado;
            response.flagTransportePrivado = response.idModalidadTraslado === PRIVADO ? true : false;
            this.setState({
                visible: true,
                formValues: response
            });
        }
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await vehiculoService.registrar(values);
            else
                response = await vehiculoService.modificar(values);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                form.setFieldsValue(empty);
                form.resetFields();
                this.setState({ visible: false, formValues: empty });

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }
            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }
            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    async componentDidMount() {
        this._initPagination(this.state.filter, vehiculoService.paginacion);
        
        const choferes = await choferService.listar();
        const transportes = await transporteService.listar();
        const modalidadTraslado = await modalidadTrasladoService.listar();
        this.setState({
            loadingSource: false,
            choferes: choferes ? choferes : [],
            transportes: transportes ? transportes : [],
            modalidadTraslado: modalidadTraslado ? modalidadTraslado : [],
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Vehiculo"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}
                    onEdit={this.handleEdit}
                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onChange={this.handleChangeForm}
                />
            </div>
        )
    }
}

